import gql from "graphql-tag";
import {
  SubmitPaymentDetailsInput,
  SubmitPaymentDetailsResponse,
} from "src/types/graphql.d";
import { ApolloError } from "@apollo/client";
import { useMutation } from "@apollo/react-hooks";
import { useCallback } from "react";
import { ExecutionResult } from "graphql";

interface SubmitPaymentDetailsData {
  submitPaymentDetails: SubmitPaymentDetailsResponse;
}

interface SubmitPaymentDetailsHook {
  submitPaymentDetails: (
    variables: SubmitPaymentDetailsInput
  ) => Promise<ExecutionResult<SubmitPaymentDetailsData>>;
  data: SubmitPaymentDetailsData | null | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

const SUBMIT_PAYMENT_DETAILS = gql`
  mutation submitPaymentDetails($data: SubmitPaymentDetailsInput!) {
    submitPaymentDetails(data: $data) {
      success
    }
  }
`;

const useSubmitPaymentDetails = ({
  refetchQueries = [],
}: {
  refetchQueries?: string[];
}): SubmitPaymentDetailsHook => {
  const [submitPaymentDetailsMutation, { data, loading, error }] =
    useMutation<SubmitPaymentDetailsData>(SUBMIT_PAYMENT_DETAILS, {
      refetchQueries,
    });

  const submitPaymentDetails = useCallback(
    async (data: SubmitPaymentDetailsInput) =>
      await submitPaymentDetailsMutation({
        variables: {
          data,
        },
      }),
    [submitPaymentDetailsMutation]
  );

  return {
    submitPaymentDetails,
    data,
    loading,
    error,
  };
};

export default useSubmitPaymentDetails;
